// extracted by css-extract-rspack-plugin
export default {"loadingAnimation":"_aad5cdd0","shimmerLoadingBackground":"_53d3628d","titlePlaceholder":"_75ef3323","tile":"_220c8254","images":"_8d4986f4","shopAll":"_bbc55985"};